import { createMuiTheme } from '@material-ui/core/styles';
import { white } from '@material-ui/core/colors';
import spacing from '@material-ui/core/styles/spacing';
import { lighten } from '@material-ui/core/styles/colorManipulator';

const primaryColor = '#00A99D';
const secondaryColor = '#f50057';

export default createMuiTheme({
    spacing: {
        ...spacing,
        /* custom width and height */
        maxWidth: 980,
        maxActionComponentHeight: 68,
    },
    shape: {
        borderRadius: 2,
    },
    overrides: {
        MuiIconButton: {
            root: {
                width: 35,
                height: 35,
            },
        },
        MuiPaper: {
            root: {
                minHeight: 68,
            },
        },
        MuiPopover: {
            paper: {
                boxShadow:
                    '0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)',
            },
        },
        MuiInput: {
            root: {
                width: '100%',
                fontSize: 14,
            },
            underline: {
                '&:before': {
                    borderBottom: '1px solid #e8e8e8 !important',
                },
                '&:hover:not($disabled):before': {
                    borderBottom: '1px solid #e8e8e8 !important',
                },
                '&:after': {
                    transition: 'none',
                },
            },
        },
        MuiDialog: {
            paper: {
                minWidth: 300,
            },
        },
        MuiDialogActions: {
            root: {
                margin: spacing.unit * 2,
            },
            action: {
                margin: 0,
            },
        },
        MuiButton: {
            flat: {
                '&:hover': {
                    backgroundColor: 'transparent',
                    color: 'rgba(0, 0, 0, 0.7)',
                },
            },
            flatPrimary: {
                '&:hover': {
                    backgroundColor: 'transparent',
                    color: lighten(primaryColor, 0.4),
                },
            },
            containedPrimary: {
                '&:hover': {
                    backgroundColor: lighten(primaryColor, 0.4),
                },
                color: 'white',
                boxShadow: 'none',
            },
            containedSecondary: {
                '&:hover': {
                    backgroundColor: lighten(secondaryColor, 0.4),
                    color: white,
                },
                boxShadow: 'none',
            },
        },
        MuiAvatar: {
            root: {
                width: 36,
                height: 36,
            },
        },
        MuiAppBar: {
            colorDefault: {
                backgroundColor: white,
            },
        },
        MuiTableCell: {
            numeric: {
                width: 60,
            },
        },
    },
    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },
    typography: {
        fontFamily: 'Lato, sans-serif',
        button: {
            textTransform: 'none',
        },
        headline: {
            fontSize: 22,
        },
        title: {
            fontSize: 18,
        },
        caption: {
            fontSize: 14,
        },
    },
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: primaryColor,
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            main: secondaryColor,
        },
        background: {
            gray1Color: '#f5f6f7',
            gray2Color: 'rgba(0, 0, 0, 0.1)',
            gray3Color: '#EEEEEE',
        },
        info: {
            main: '#F7FDFD',
            secondary: '#66CBC4',
        },
        text: {
            primary: '#232b3b',
            secondary: '#9d9d9d',
            tertiary: '#060633',
            gray: '#838383',
            gray2: '#767676',
        },
        separator: {
            main: '#DDDDDD',
        },
        border: {
            main: '#E2E2E2',
        },
    },
    /* custom components */
    avatar: {
        // Normal avatar size defined in overrides for MuiAvatar
        large: { height: 68, width: 68 },
        extraLarge: {
            height: 150,
            width: 150,
            background: '#E2E2E2',
        },
    },
    divider: {
        bulletBackground: '#D8D8D8',
        verticalBorder: '1px solid rgba(35, 43, 59, 0.05)',
        horizontalBorder: '1px solid rgba(157, 157, 157, 0.15)',
    },
    bucket: {
        width: 275,
    },
    menu: {
        width: 300,
    },
    tab: {
        itemWidth: 120,
    },
    cover: {
        titleWidth: 500,
    },
    publishIndicator: {
        animationDuration: 3000,
    },
});



// WEBPACK FOOTER //
// ./src/helpers/Theme.js